import { render, staticRenderFns } from "./ProjectAssetDeleteAction.vue?vue&type=template&id=5708db04"
import script from "./ProjectAssetDeleteAction.vue?vue&type=script&lang=js"
export * from "./ProjectAssetDeleteAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports